import ReturnsTable from "./returnsTable.jsx";
export default ReturnsTable;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/returnsTable/index.js